import DramaCard from '@/components/base/DramaCard';
import type { Drama } from '@/mocks/dramas';

interface LatestDramasProps {
  dramas: Drama[];
}

export default function LatestDramas({ dramas }: LatestDramasProps) {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              热播好剧每日准时更新
            </p>
          </div>
          <div className="flex items-center gap-1 text-sm text-primary-500 whitespace-nowrap">
            <i className="ri-time-line text-sm"></i>
            每日更新
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-5">
          {dramas.filter((d) => d.isNew).map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}